export var ThirdPartyCallBack;
(function (ThirdPartyCallBack) {
    ThirdPartyCallBack["SessionExpire"] = "SessionExpire";
    ThirdPartyCallBack["BuySell"] = "BuySell";
    ThirdPartyCallBack["DownloadReport"] = "DownloadReport";
    ThirdPartyCallBack["Pledge"] = "Pledge";
})(ThirdPartyCallBack || (ThirdPartyCallBack = {}));
export var LoginSource;
(function (LoginSource) {
    LoginSource["IPHONE"] = "iphone";
    LoginSource["ANDROID"] = "android-phone";
    LoginSource["TX3"] = "X";
    LoginSource["SALES"] = "sales";
})(LoginSource || (LoginSource = {}));
export const EMTReportCallBack = (loginSrc, type, data) => {
    const windowX = window;
    let callBack = {};
    switch (type) {
        case ThirdPartyCallBack.SessionExpire:
            callBack[LoginSource.IPHONE] = () => {
                var _a, _b;
                if ((_b = (_a = windowX === null || windowX === void 0 ? void 0 : windowX.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.onSessionExpired) {
                    windowX.webkit.messageHandlers.onSessionExpired.postMessage({
                        status: "true",
                    });
                }
            };
            callBack[LoginSource.ANDROID] = () => {
                var _a;
                if ((_a = windowX === null || windowX === void 0 ? void 0 : windowX.EDREVAMPJsBridge) === null || _a === void 0 ? void 0 : _a.onSessionExpired)
                    windowX.EDREVAMPJsBridge.onSessionExpired();
            };
            break;
        case ThirdPartyCallBack.BuySell:
            callBack[LoginSource.IPHONE] = () => {
                var _a, _b;
                if ((_b = (_a = windowX === null || windowX === void 0 ? void 0 : windowX.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.onBuySell)
                    windowX.webkit.messageHandlers.onBuySell.postMessage({
                        data,
                    });
            };
            callBack[LoginSource.ANDROID] = () => {
                var _a;
                if ((_a = windowX === null || windowX === void 0 ? void 0 : windowX.EDREVAMPJsBridge) === null || _a === void 0 ? void 0 : _a.onBuySell)
                    windowX.EDREVAMPJsBridge.onBuySell(JSON.stringify(data));
            };
            break;
        case ThirdPartyCallBack.DownloadReport:
            callBack[LoginSource.IPHONE] = () => {
                var _a, _b;
                if ((_b = (_a = windowX === null || windowX === void 0 ? void 0 : windowX.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.downloadReport)
                    windowX.webkit.messageHandlers.downloadReport.postMessage({
                        method: data === null || data === void 0 ? void 0 : data.method,
                        fileFormat: data === null || data === void 0 ? void 0 : data.fileFormat,
                        reportType: data === null || data === void 0 ? void 0 : data.reportType,
                        params: data === null || data === void 0 ? void 0 : data.params,
                    });
            };
            callBack[LoginSource.ANDROID] = () => {
                var _a;
                if ((_a = windowX === null || windowX === void 0 ? void 0 : windowX.EDREVAMPJsBridge) === null || _a === void 0 ? void 0 : _a.downloadReport)
                    windowX.EDREVAMPJsBridge.downloadReport(JSON.stringify(data));
            };
            break;
        default:
            console.log("did not found this case " + type);
    }
    if (callBack[loginSrc])
        callBack[loginSrc]();
    else
        console.log("did not found any call back on " + loginSrc);
};
export const triggerDownloadReportCallback = (method, fileFormat, reportType, params, loginSource) => {
    const data = {
        method: method,
        fileFormat: fileFormat,
        reportType: reportType,
        params: params,
    };
    EMTReportCallBack(loginSource, ThirdPartyCallBack.DownloadReport, data);
};
export const isLoginSourceEMT = (loginSource, reverse) => {
    return (loginSource &&
        (loginSource === LoginSource.IPHONE || loginSource === LoginSource.ANDROID));
};
